import SvgIcon from "../../helpers/SvgIcon";
import type { ActionMenuKind } from "./actionMenu.interface";
import { actionMenuKindIcons } from "./actionMenuKindConfig";

function ActionMenuKindIndicator({ kind }: { kind?: ActionMenuKind }) {
  if (!kind) return null;

  return (
    <span
      aria-hidden="true"
      className="ml-3 inline-flex h-4 w-4 shrink-0 items-center justify-center opacity-60 [&_svg]:!h-4 [&_svg]:!w-4">
      <SvgIcon type={actionMenuKindIcons[kind]} fill="currentColor" />
    </span>
  );
}

export default ActionMenuKindIndicator;
